var _circle, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FFE4E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9286 26.9285H19.7858",
    stroke: "#E11D48",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7858 19.7856H26.9286",
    stroke: "#E11D48",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7858 23.3569H26.9286",
    stroke: "#E11D48",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6107 14.3846C26.9919 15.2721 26.3011 16.2141 25.3351 16.2141H21.3402C20.3858 16.2141 19.6952 15.2926 20.0592 14.4103C20.8538 12.4843 21.873 11.0892 23.3572 9.07129C24.7822 11.084 25.7901 12.4745 26.6107 14.3846Z",
    fill: "#FECDD3",
    stroke: "#E11D48",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.643 26.9285C14.6154 26.9285 16.2144 25.3295 16.2144 23.3571C16.2144 21.3846 14.6154 19.7856 12.643 19.7856C10.6705 19.7856 9.07153 21.3846 9.07153 23.3571C9.07153 25.3295 10.6705 26.9285 12.643 26.9285Z",
    fill: "#FECDD3",
    stroke: "#E11D48",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2173 14.7473C9.29332 15.433 9.84233 15.9818 10.5278 16.0607C11.2132 16.1395 11.9203 16.2141 12.643 16.2141C13.3656 16.2141 14.0727 16.1395 14.7582 16.0607C15.4436 15.9818 15.9926 15.433 16.0686 14.7473C16.1442 14.0652 16.2144 13.3617 16.2144 12.6427C16.2144 11.9237 16.1442 11.2202 16.0686 10.5382C15.9926 9.85242 15.4436 9.30361 14.7582 9.22478C14.0727 9.14594 13.3656 9.07129 12.643 9.07129C11.9203 9.07129 11.2132 9.14594 10.5278 9.22478C9.84233 9.30361 9.29332 9.85242 9.2173 10.5382C9.14169 11.2202 9.07153 11.9237 9.07153 12.6427C9.07153 13.3617 9.14169 14.0652 9.2173 14.7473Z",
    fill: "#FECDD3",
    stroke: "#E11D48",
    strokeWidth: 2.14286
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.26720b05eb2d88183037128491b21bab.svg";
export { ForwardRef as ReactComponent };